<template>
    <div class="dynamic-attr-text dynamic-attr-file"
        :class="(attrObj.isCheckError?'is-check-error':'')">
        <div :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
            :style="{fontSize:$pScreen.titleS}">
            <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
        </div>
        <div class="text-item-value"
            :style="{fontSize:$pScreen.titleS, 'margin-bottom': attrObj.isCheckError ? '0' : '15px'}">
            <!-- accept="image/*,video/*"  -->        
            <div v-if="isWxBrowser && attrObj.attachmentType=='0' && isEditFlag"
                class="out-upload">
                <div class="out-content">
                    <div v-for="(item, index) in fileList"
                        :key="index"
                        class="content-img">
                        <img :src="item.path"
                            alt=""
                            class="img-item"
                            @click="openPreview(item.path)">
                        <div class="img-delete"
                            @click="deleteImg(index)">
                            <van-icon class="img-delete-icon"
                                name="cross" />
                        </div>
                    </div>
                    <div v-if="fileList.length<9&&isEditFlag"
                        class="content-img content-img-upload">
                        <van-button icon="plus"
                            type="primary"
                            class="content-upload"
                            @click="wxChose"></van-button>
                        <div v-if="isEditFlag"
                            class="out-upload-type">上传{{attrObj.attachmentType=='0'?'图片':'视频'}}</div>
                    </div>
                </div>
                <div v-if="previewData.isPreview"
                    class="out-preview"
                    @click="closePreview(index)">
                    <img :src="previewData.previewImg"
                        alt=""
                        class="preview-img">
                    <div class="preview-close">
                        <van-icon class="preview-close-icon"
                            name="cross" />
                    </div>
                </div>
            </div>
            <van-uploader v-else
                :accept="attrObj.attachmentType!='0'?'video/*':'image/*'"
                v-model="fileList"
                v-show="attrObj.attachmentType!='0' ? !fileList.length : true"
                :before-read="beforeRead"
                :after-read="afterRead"
                :deletable="isEditFlag"
                :disabled="!isEditFlag"
                @click-preview="handleAgainUpload"
                :multiple="attrObj.attachmentType=='0'?true:false"
                result-type="file">
                <van-button icon="plus"
                    type="primary"
                    class="uploadBorderButton"
                    v-if="fileList.length<9&&isEditFlag"
                    :disabled="!isEditFlag"></van-button>
                <div class="upload-type-name"
                    v-if="isEditFlag && fileList.length<9">上传{{attrObj.attachmentType=='0'?'图片':'视频'}}</div>
            </van-uploader>

            <!-- 视频封面预览 -->
            <div v-if="attrObj.attachmentType!='0'&&fileList.length"
                class="previewCover"
                @click="handlePreviewVideo">
                <div class="masking"></div>
                <video preload="auto"
                    x5-video-player-type="h5"
                    playsinline="true"
                    poster="../../../../../static/runtime/images/magic/logoNew.png"
                    v-html="videoSrc"></video>
                <!-- 播放按钮 -->
                <van-icon name="play-circle-o"
                    class="videoIcon1"
                    v-if="uploadStatus.status=='done'||isCommandOutput" />
                <!-- 上传中，过渡状态 -->
                <div v-else
                    class="videoLoading">
                    <van-loading size="24px"
                        vertical
                        color="#FFFFFF"
                        v-if="uploadStatus.status=='uploading'">上传中...</van-loading>
                    <div v-if="uploadStatus.status=='failed'"
                        @click="handleAgainUpload(fileList[0])"
                        class="videoFailed">
                        <van-icon name="close" />
                        <div>上传失败</div>
                    </div>
                </div>
                <!-- 删除按钮 -->
                <div class="videoIcon2"
                    @click.stop="handleDeleteVideo"
                    v-if="isEditFlag&&uploadStatus.status!='uploading'">
                    <van-icon name="cross" />
                </div>
            </div>
        </div>
        <div v-if="attrObj.isCheckError"
            class="errorTip">{{uploadStatus.status=='uploading'?'请等待文件上传完毕':'请上传附件'}}</div>

        <!-- 视频蒙层预览 -->
        <div v-if="isPreviewVideo"
            class="previewBackground"
            @click.stop="isPreviewVideo=false">
            <video :src="fileList[0].content"
                v-if="fileList.length"
                preload="auto"
                x5-video-player-type="h5"
                playsinline="true"
                @click.stop=""
                controls="controls">
            </video>
        </div>
    </div>
</template>

<script>
import { Uploader, Button, Icon, Toast, Loading } from 'vant';
import wx from 'weixin-js-sdk';
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
  },
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      channelFile: [],
      fileList: [],
      isPreviewVideo: false, // 是否预览
      isCommandOutput: false, // 是否附件回显
      isEditFlag: false, // 是否可修改
      uploadStatus: {}, // 上传状态
      videoSrc: '',
      isWxBrowser: false,
      previewData: {
        isPreview: false,
        previewImg: '',
      },
    };
  },
  created() {
    this.isWxBrowser = this.$utils.isWxBrowser();
    this.init()
  },
  watch: {
    fileList: {
      handler(val) {
        if (this.isEditFlag) this.attrObj.answerContent = this.$utils.deepCopy(this.fileList);
      },
      deep: true,
      immediate: true,
    },
    attrObj: {
      handler(val) {
        // 初始化的时候会监听到，，上传图片视频也会监听到，但不应该执行初始化方法，如果执行了会把上传的文件清除
        // 只有在查看历史，获得答案后监听到时，才应该执行初始方法，让图片照片回显
        if(val && val.needUpdate){
          this.init()
        }
      },
      // deep: true,  不要deep，如果deep会和上面的fileList 互相监听，互相赋值 一直循环执行
      immediate: true,
    },
  },
  methods: {
    // 只有趣味表单才展示题号
    showNum(item, current) {
      if (item.formType !== FormType.interestForm) {
        return '';
      } else {
        return `${current + 1}.`;
      }
    },
    init() {
      setTimeout(()=>{
        const attrData = JSON.parse(JSON.stringify(this.attrObj));
        this.attrObj.answerContent = [];
        if(attrData.disabled) {
          this.isEditFlag= false;
        }else {
          this.isEditFlag = true;
        }
        this.fileList = [];
        if (Array.isArray(attrData.desc) && attrData.desc.length > 0) {
          this.isCommandOutput = true;
          attrData.desc.forEach((element) => {
            const file = {
              url: element,
              content: element,
              file: element,
              path: element,
              status: "done"
            };
            this.fileList.push(file);
          });
        }
      },500)     
    },
    /**
     * 删除上传的视频
     * @author <fangyan f84162999>
     */
    handleDeleteVideo() {
      this.uploadStatus = {};
      this.fileList = [];
    },

    /**
     * 预览上传的视频
     * @author <fangyan f84162999>
     */
    handlePreviewVideo() {
      if (this.uploadStatus.status !== 'done' && !this.isCommandOutput) return;
      this.isPreviewVideo = true;
    },

    /**
     * 上传前的处理
     * @param {Object} file: 所操作文件对象
     * @author <fangyan f84162999>
     */
    beforeRead(file) {
      let isBatch = true;
      if (!Array.isArray(file)) {
        isBatch = false;
        file = [file];
      }
      console.log('共' + file.length + '张');
      if (file.length > 9) {
        Toast(`选择的图片太多啦，请重新选择上传`);
        return false;
      }
      if (this.attrObj.attachmentType == '1') {
        file = [file[0]];
      }
      return file.every((element, index) => {
        if (element.type.toLowerCase().indexOf('image') > -1) {
          if (element.size > 5 * 1024 * 1024) {
            if (isBatch) {
              Toast(`第${index + 1}张图片超过5M，请删除后重新选择上传`);
            } else {
              Toast('上传失败，请上传大小在5M内的图片');
            }
            return false;
          }
          const isSome = ['JPG', 'PNG', 'JPEG', 'GIF'].some((item) => {
            return element.type.toLowerCase().indexOf(item.toLowerCase()) > -1;
          });
          if (!isSome) {
            if (isBatch) {
              Toast(`第${index + 1}张图片格式错误，请删除后重新选择上传`);
            } else {
              Toast('上传失败，请上传JPG/PNG/JPEG/GIF格式类型图片');
            }
            return false;
          }
        } else {
          if (element.size > 100 * 1024 * 1024) {
            Toast('上传失败，请上传大小在100M内的视频内容');
            return false;
          }
        }
        return true;
      });
    },

    /**
     * 文件读取完成后的回调函数，vant组件自带
     * @param {Object} file: 所操作文件对象
     * @author <fangyan f84162999>
     */
    afterRead(file) {
      console.log('文件读取完成', file);
      this.fileList.forEach((element) => {
        if (!element.status) {
          element.status = 'uploading';
          element.message = '上传中...';
          this.uploadStatus = { ...element };
          this.handleUpload(element);
        }
      });
    },

    /**
     * 将文件上传至服务器
     * @param {Object} file: 所操作文件对象
     * @param {String} base64: 所操作文件转base64
     * @author <fangyan f84162999>
     */
    handleUpload(file, base64) {
      file.path = '';
      const params = new FormData();
      params.append('file', file.file);
      this.$api.form('POST', {
        noLoading: true,
        sc: 'mobileMarketing',
        url: `file/upload`,
        params: params,
        headers: { 'Content-Type': 'multipart/form-data' },
        success: (res) => {
          if (res && res.code == 200) {
            let result = res.result;
            if (result) {
              this.$set(this.attrObj, 'isCheckError', false);
              file.status = 'done';
              file.message = '上传成功';
              this.uploadStatus = { ...file };
              result = JSON.parse(result).fileUrl;
              const fileType = this.attrObj.attachmentType == '0' ? 'image' : 'video';
              file.path = this.$utils.getImageUrl(result, fileType);
              console.log('上传文件类型', fileType, file.path, 2);
              if (this.attrObj.attachmentType == '1') {
                const index = file.path.lastIndexOf('.');
                this.videoSrc = `<source src='${file.path}' type='video/${file.path.substring(index + 1)}'>`;
              }
              file.content = file.path;
              file = { ...file };
            }
          } else {
            file.status = 'failed';
            file.message = '上传失败';
            this.uploadStatus = { ...file };
          }
        },
        failure: (err) => {
          file.status = 'failed';
          file.message = '上传失败';
          this.uploadStatus = { ...file };
        },
      });
    },

    /**
     * 点击预览,如果当前文件没有上传成功则重新上传
     * @param {Object} file: 当前文件对象
     * @author <fangyan f8162999>
     */
    handleAgainUpload(file) {
      console.log('重新上传', file);
      if (file.status === 'failed') {
        file.status = 'uploading';
        file.message = '上传中...';
        this.uploadStatus = { ...file };
        this.handleUpload(file);
      } else {
        return;
      }
    },
    wxChose() {
      const that = this;
      console.log('8888888888');
      const count = 9 - this.fileList.length;
      wx.chooseImage({
        count: count,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function (data) {
          const localIds = [];
          data.localIds.forEach((el) => {
            localIds.push(el);
          });
          console.log(localIds, '选择图片');
          that.wxUploadImage(localIds);
        },
        fail: (err) => {
          console.log('88888-err', err);
          console.log('88888-err.message', err.message);
          that.isWxBrowser = false;
        },
      });
    },
    wxUploadImage(localIds) {
      if (localIds) {
        const that = this;
        wx.uploadImage({
          localId: localIds.pop(),
          isShowProgressTips: 1,
          success: function (res) {
            console.log(res.serverId, '上传微信服务器');
            that.fileUpload(res.serverId);
            that.wxUploadImage(localIds);
          },
        });
      }
    },
    fileUpload(mediaId) {
      let file = {};
      this.$api.form('POST', {
        noLoading: true,
        sc: 'mobileMarketing',
        url: `file/upload?loginType=weChat&mediaId=${mediaId}`,
        success: (res) => {
          if (res && res.code == 200) {
            let result = res.result;
            if (result) {
              this.$set(this.attrObj, 'isCheckError', false);
              file.status = 'done';
              file.message = '上传成功';
              this.uploadStatus = { ...file };
              result = JSON.parse(result).fileUrl;
              const fileType = this.attrObj.attachmentType == '0' ? 'image' : 'video';
              file.path = this.$utils.getImageUrl(result, fileType);
              console.log('上传文件类型', fileType, file.path, 1);
              file.content = file.path;
              file = { ...file };
              this.fileList.push(file);
            }
          } else {
            file.status = 'failed';
            file.message = '上传失败';
            this.uploadStatus = { ...file };
          }
        },
        failure: (err) => {
          file.status = 'failed';
          file.message = '上传失败';
          this.uploadStatus = { ...file };
        },
      });
    },
    deleteImg(index) {
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
    },
    openPreview(url) {
      this.previewData.isPreview = true;
      this.previewData.previewImg = url;
    },
    closePreview() {
      this.previewData.isPreview = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.disabledBtn {
  background: #f7f7f7 !important;
  color: #ccc !important;
}
.text-item-value {
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  /deep/ .van-uploader__wrapper--disabled {
    opacity: 1;
  }
  /deep/ .van-uploader {
    width: 100%;
    .van-uploader__wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .van-uploader__preview {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        margin-right: 15px;
        position: relative;
        &::before {
          content: '';
          padding-top: 100%;
          vertical-align: middle;
          display: block;
        }
        .van-image.van-uploader__preview-image,
        .van-uploader__file {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          overflow: initial;
        }
        .van-uploader__preview-delete {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          opacity: 0.2;
          background: #1a1a1a;
          display: flex;
          justify-content: center;
          align-content: center;
          top: -10px;
          right: -10px;
          i {
            position: static;
            font-size: 16px;
            transform: none;
            line-height: 20px;
          }
        }
      }
      .van-uploader__input-wrapper {
        width: 120px;
        height: 60px;
        margin-right: 3%;
        position: relative;
        &::before {
          content: '';
          padding-top: 100%;
          vertical-align: middle;
          display: block;
        }
        .uploadBorderButton {
          width: 60px;
          height: 60px;
          background: #f8f8f8;
          border: none;
          color: #e0e0e0;
          font-size: 24px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .upload-type-name {
          position: absolute;
          top: 0;
          left: 70px;
          width: 80px;
          height: 60px;
          display: flex;
          color: #000000;
          justify-content: center;
          align-items: center;
          font-size: 12px !important;
        }
      }
      .van-uploader__upload {
        display: none;
      }
    }
  }
  .previewCover {
    width: 30%;
    height: 100%;
    margin-right: 3%;
    position: relative;
    &::before {
      content: '';
      padding-top: 100%;
      vertical-align: middle;
      display: block;
    }
    .masking {
      width: 100%;
      height: 100%;
      background: rgba(29, 30, 40, 0.5);
      position: absolute;
      top: 0;
      z-index: 100;
    }
    video {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      width: 100%;
      max-height: 100%;
      z-index: 99;
    }
    .videoIcon1 {
      font-size: 28px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      z-index: 101;
    }
    .videoLoading {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      z-index: 101;
      i {
        font-size: 28px;
      }
      .van-loading__text {
        color: #ffffff;
      }
      .videoFailed {
        text-align: center;
      }
    }
    .videoIcon2 {
      width: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      right: -10px;
      opacity: 0.2;
      background: #1a1a1a;
      border-radius: 50%;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      z-index: 101;
    }
  }
}
.previewBackground {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 1000;
  display: flex;
  align-items: center;
  left: 0;
  top: 0;
  video {
    background: black;
    width: 100%;
    max-height: 240px;
  }
}
.out-upload {
  width: 100%;
  .out-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .content-img {
      width: 60px;
      height: 60px;
      position: relative;
      margin-right: 15px;
      margin-bottom: 10px;
      .img-item {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        overflow: initial;
      }
      .img-delete {
        position: absolute;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        opacity: 0.5;
        background: #1a1a1a;
        display: flex;
        justify-content: center;
        top: -6px;
        right: -6px;
        .img-delete-icon {
          position: static;
          font-size: 10px !important;
          transform: none;
          line-height: 15px;
          color: #ffffff;
        }
      }
      .content-upload {
        width: 60px;
        height: 60px;
        background: #f8f8f8;
        border: none;
        color: #e0e0e0;
        font-size: 24px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .content-img::before {
      content: '';
      padding-top: 100%;
      vertical-align: middle;
      display: block;
    }
    .content-img-upload {
      width: 130px;
    }
    .out-upload-type {
      position: absolute;
      display: flex;
      align-items: center;
      top: 0;
      left: 80px;
      width: 80px;
      height: 60px;
      color: #000000;
      font-size: 12px !important;
    }
  }
}
.out-preview {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  z-index: 999;
  .preview-img {
    display: block;
    width: 100vmin;
    height: 100vmin;
    margin: auto;
  }
  .preview-close {
    position: absolute;
    top: 15px;
    right: 15px;
    height: 26px;
    width: 26px;
    color: #ffffffd9;
    border: 1px solid #ffffffd9;
    border-radius: 50%;
    .preview-close-icon {
      width: 100%;
      height: 100%;
      font-size: 20px;
      margin: 2px 0 0 2px;
    }
  }
}
</style>
<style lang="scss">
.uploadButton {
  background-color: #40b2f4 !important;
  border-color: #40b2f4 !important;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/fileUpload.vue